module.exports = __webpack_public_path__ + "img/pr-1.af631656.png";